import * as React from 'react';
import { UserApi } from "../apiLayer/UserApi";
import { RioResources, RioConfirmModal, RioIconButton, RioIfFunc } from "rio.react.all";
import { UserAddUpdateModal } from "../modals/UserAddUpdate";
import { UserApiModel } from '../apiModels/UserApiModel';
import { Page } from '../components/Page';
import { DataVineGridView } from '../components/GridView/GridView';
import { IGridViewColumn } from '../components/GridView/IGridViewColumn';
import { IGridViewAction } from '../components/GridView/IGridViewAction';

interface UsersProps {
}

interface UsersState {
    // UI State
    loading: boolean;
    selectedUserId?: number;
    deleteUserId?: number;
    users: UserApiModel[];
}

export class Users extends React.Component<UsersProps, UsersState> {
    constructor(props: UsersProps) {
        super(props);
        this.state = {
            loading: false,
            selectedUserId: null,
            deleteUserId: null,
            users: []
        };
    }

    columns: Array<IGridViewColumn<UserApiModel>> = [
        { title: RioResources.find("FirstName").text, value: (item) => item.firstName },
        { title: RioResources.find("LastName").text, value: (item) => item.lastName },
        { title: RioResources.find("Email").text, value: (item) => item.email },
    ];

    actions: Array<IGridViewAction<UserApiModel>> = [
        { resource: RioResources.find("Delete"), onClick: (item) => this.handleDeleteClicked(item), default: false, hasPermission: true },
        { resource: RioResources.find("Edit"), onClick: (item) => this.handleEditClicked(item), default: true, hasPermission: true },
    ];

    componentDidMount() {
        this.getUsers();
    }

    getUsers() {
        UserApi.getUsers()
            .then(response => {
                this.setState({
                    users: response,
                    loading: false
                });
            })
            .catch(errors => {
                this.setState({
                    users: [],
                    loading: false
                });
            });
    }

    render() {
        return (
            <Page heading={RioResources.find("Users")}>

                <div className="newUserButtonWrapper">
                    <RioIconButton resource={RioResources.find("NewUser")} className="newUserButton" onClick={() => this.addUser()} hasPermission={true}></RioIconButton>
                </div>
                <DataVineGridView<UserApiModel>
                    noResults={RioResources.find("NoResultsFound")}
                    columns={this.columns}
                    actions={this.actions}
                    items={this.state.users}
                    rowKey={(item: UserApiModel) => item.userID}
                />

                <RioIfFunc condition={this.state.selectedUserId != null} then={() => {
                    return (
                        <UserAddUpdateModal userId={this.state.selectedUserId.toString()} onClose={() => this.handleUserModalClosed()} />
                    );
                }} />
                <RioIfFunc condition={this.state.deleteUserId != null} then={() => {
                    return (
                        <RioConfirmModal text={RioResources.find("ConfirmDelete")} onConfirmModalClosed={(result) => this.handleConfirmModalClosed(result)} hideImage={true} className="confirmModal" />
                    );
                }} />
            </Page>
        );
    }

    renderUserAddUpdateModal() {
    }

    handleUserModalClosed() {
        this.setState({
            selectedUserId: null
        });
        this.getUsers();
    }

    clear() {
    }

    handleDeleteClicked(user: UserApiModel): void {
        this.setState({
            deleteUserId: user.userID
        });
    }

    handleConfirmModalClosed(result: boolean) {
        if (result) {
            UserApi.deleteUser(this.state.deleteUserId)
                .then(response => {
                    this.setState({
                        deleteUserId: null
                    });
                    this.getUsers();
                });
        }
        else {
            this.setState({
                deleteUserId: null
            });
        }
    }

    handleEditClicked(user: UserApiModel): void {
        this.setState({
            selectedUserId: user.userID
        });
    }

    addUser(): void {
        this.setState({
            selectedUserId: 0
        });
    }
}